import { setMap } from '../../map_utils/index'
import Accordion from './Accordion/index'
import { SidePanelType } from '../../interfaces/index'
import { useStateMachine } from 'little-state-machine'
import { updateStore } from '../../state'

const SidePanel = ({
  fresh,
  content,
  markers,
  resetMapData,
  setIsOpen,
  scrollToMap,
  map
}: SidePanelType) => {
  const { state, actions } = useStateMachine({ updateStore })
  const setLocation = setMap(markers, map)
  if (!content?.length && state?.address) {
    return (
      <div className="wc-outages__sidepanel bg-ocean">
        <div className="wc-outages__sidepanel__title">
          <h3 className="h6 wc-outages__sidepanel__title--h3">
            Outages by suburb:
          </h3>
        </div>
        <div className="wc-outages__sidepanel__panel wc-outages__sidepanel__panel--notfound">
          <h5>{state?.address.split(',')[0]}</h5>
          <h6>There are no known outages at this address</h6>
          <p>
            If you are experiencing a water outage at this address, please
            report the outage to one of our 24 hour support crew, so we can
            investigate. <a href={state?.reportFormUrl}>Report a fault</a>
          </p>
        </div>
        <div className="wc-outages__sidepanel__reset">
          <button
            onClick={() => {
              actions.updateStore({
                address: ''
              })
              resetMapData()
            }}
            className="wc-outages__button--reset"
          >
            <h6>Reset Map</h6>
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className="wc-outages__sidepanel bg-ocean">
      <div className="wc-outages__sidepanel__title">
        <h3 className="h6 wc-outages__sidepanel__title--h3">
          Outages by suburb:
        </h3>
      </div>
      <div className="wc-outages__sidepanel__panel">
        {content?.length > 0 && (
          <Accordion
            id="sidepanel-ac"
            content={content}
            setLocation={setLocation}
            setIsOpen={setIsOpen}
            scrollToMap={scrollToMap}
          />
        )}
      </div>
      <div className="wc-outages__sidepanel__reset">
        {!fresh && (
          <button
            onClick={() => {
              actions.updateStore({
                address: ''
              })
              resetMapData()
            }}
            className="wc-outages__button--reset"
          >
            <h6>Reset Map</h6>
          </button>
        )}
      </div>
    </div>
  )
}

export default SidePanel
